export const environment = {
    production: true,
    hostUrl: 'https://prod.explainapi.co.uk',
    apiUrl: 'https://prod.explainapi.co.uk/api/v1',
    whitelist: ['prod.explainapi.co.uk'],
    blacklist: ['/login'],
    primaryColor: '#1c7985',
    accentColor: '#c93457',
    masterGaId: 'G-DSD0FGDB93',
    environmentName: 'production',
    SocketIoUrl: 'https://sockets.explainapi.co.uk',
    favicon16: '/assets/favicon/favicon-16.png',
    favicon32: '/assets/favicon/favicon-32.png',
    appleTouchIcon: '/assets/favicon/apple-touch-icon.png',
};

